<template>
  <div class="fix-tab-Item">
    <div class="hidden">
      <div class="hidden-Item">
        <div class="item-part1">主要隐患</div>
        <div class="item-part2">
          <span class="risk-tag">{{ AlertLevel.name(items.mainRiskId) }}</span>
        </div>
      </div>
      <div class="hidden-Item" style="display: none;">
        <div class="item-part1">隐患列表</div>
        <div class="item-part2">
        <span v-for="(a,index) in items.riskIds" :key="index">
          {{ AlertLevel.name(a) }}
        </span>
        </div>
      </div>
      <div class="hidden-Item">
        <div class="item-part1">目标时间</div>
        <div class="item-part2">{{ items.analysisTargetTime }}</div>
      </div>
      <div class="hidden-Item">
        <div class="item-part1">问题描述</div>
        <div class="item-part3">{{ items.content }}</div>
      </div>
      <div class="hidden-Item">
        <div class="item-part1">创建时间</div>
        <div class="item-part2">{{ items.createTime }}</div>
      </div>
      <div class="hidden-status" :class="statusClass">{{ hiddenStatus }}</div>
      <div class="hidden-more">
        <el-button type="text" size="small" @click="handleDetail">编辑</el-button>
        <template v-if="hasPublishPermission">
          <el-popconfirm
            title="确定要发布该记录吗？"
            placement="top"
            confirm-button-text="确定"
            cancel-button-text="取消"
            confirm-button-type="primary"
            @confirm="handleUp"
            v-if="isUpShow">
            <el-button slot="reference" type="text" size="small">发布</el-button>
          </el-popconfirm>
          <el-popconfirm
            title="确定要取消发布该记录吗？"
            placement="top"
            confirm-button-text="确定"
            cancel-button-text="取消"
            confirm-button-type="warning"
            @confirm="handleCancelPublish"
            v-if="!isUpShow">
            <el-button slot="reference" type="text" size="small">取消发布</el-button>
          </el-popconfirm>
        </template>
        <el-popconfirm
          title="确定要删除该记录吗？"
          placement="top"
          confirm-button-text="确定"
          cancel-button-text="取消"
          confirm-button-type="danger"
          @confirm="handleDelete">
          <el-button slot="reference" type="text" size="small" style="color: #D61E1E">删除</el-button>
        </el-popconfirm>
      </div>
    </div>
  </div>
</template>

<script>
import AlertLevel from "../../../scripts/AlertLevel";

export default {
  computed: {
    AlertLevel() {
      return AlertLevel
    },
    hiddenStatus() {
      return this.items.publishStatus ? '已发布' : '未发布'
    },
    statusClass() {
      return this.items.publishStatus ? 'status-published' : 'status-unpublished'
    },
    isUpShow(){
      return this.items.publishStatus ? false : true
    },
    isChangeShow(){
      return this.items.publishStatus ? false : true
    }
  },
  props: {
    items: {
      type: Object,
      required: true,
    },
    hasPublishPermission: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleDetail(){
      this.$emit('handle-detail',this.items);
    },
    handleUp(){
      this.$emit('handle-up',this.items.id);
    },
    handleCancelPublish(){
      this.$emit('handle-cancel-publish',this.items.id);
    },
    handleDelete(){
      this.$emit('handle-delete',this.items.id);
    }
  }
}
</script>

<style scoped lang="less">
.fix-tab-Item{
  width: 100%;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.hidden{
  width: 100%;
  min-width: 0;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  position: relative;
  border-radius: 8px;
  border: 1px solid #E4E7ED;
  background-color: #FFFFFF;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
    border-color: #2A62FF;
  }
}

.hidden-Item{
  flex: 1;
  width: 100%;
  min-width: 0;
  display: flex;
  gap: 12px;
  align-items: center;

  .item-part1 {
    color: #252B3C;
    font-weight: 500;
    font-size: 14px;
    min-width: 70px;
    text-align: right;
  }
}

.item-part2{
  flex: 1;
  min-width: 0;
  display: flex;
  gap: 8px;
  color: #5A5E66;
  font-size: 14px;
  flex-wrap: wrap;
  align-items: center;

  span, .risk-tag {
    padding: 4px 12px;
    background-color: #F0F7FF;
    border-radius: 4px;
    color: #2A62FF;
    font-size: 14px;
    font-weight: 500;
    display: inline-block;
  }
}

.item-part3{
  width: 60%;
  min-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #5A5E66;
  font-size: 14px;
  line-height: 1.5;
}

.hidden-status{
  position: absolute;
  top: 12px;
  right: 12px;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  background-color: #F0F7FF;
  color: #2A62FF;

  &.status-unpublished {
    background-color: #F5F7FA;
    color: #909399;
  }

  &.status-published {
    background-color: #F0F7FF;
    color: #2A62FF;
  }
}

.hidden-more{
  position: absolute;
  bottom: 12px;
  right: 12px;
  display: flex;
  gap: 8px;
  align-items: center;
}

// 确认弹框样式
/deep/ .el-popconfirm {
  .el-popconfirm__main {
    margin-bottom: 12px;
    font-size: 14px;
    color: #252B3C;
    line-height: 1.6;
  }

  .el-popconfirm__action {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    margin-top: 16px;
  }
}
</style>
